<template>
  <div class="app-main" :class="{ isiframe: $route.query.isMsg == 1 }">
    <nav class="nav" v-if="$route.query.isMsg != 1">
      <div class="nav-content clearfix">
        <span class="title fl">Account 丨 用户中心</span>
        <span class="btn-logout fr" @click="doLogout">退出登录</span>
      </div>
    </nav>
    <el-scrollbar class="h100 user-box" wrapStyle="overflow-x: hidden;">
      <div class="h100">
        <section class="section-content">
          <block-one @update="requestInfo"></block-one>
        </section>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { getCookie, delCookie, setCookie } from '@/uitls'
import blockOne from './components/blockOne'

export default {
  components: {
    blockOne
  },
  data() {
    return {}
  },

  methods: {
    doLogout() {
      setCookie('accesstoken', '', -1)
      this.$router.push('/login')
    },
    // request user info
    requestInfo() {
      let token = getCookie('accesstoken')
      if (token) {
        this.$http
          .get('/user-server/user/currently', {
            params: {
              Authorization: token
            }
          })
          .then(res => {
            if (res.data.code == 200) {
              const self = this
              let json = res.data.value
              this.$store.commit('setUserInfo', json)
            } else {
              // this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log('ERROR', err)
          })
      } else {
        this.$router.push('/login')
      }
    }
  },
  mounted() {
    this.requestInfo()
  }
}
</script>

<style lang="scss" scope>
.app-main {
  background-color: #fafafa;
  width: 100%;
  height: 100%;
  padding-bottom: 48px;
  overflow: hidden;
  background: url('./../../assets/images/transfer_bg.jpg') no-repeat;
  background-position: center;
  background-size: cover;
  &.isiframe {
    background-image: none;
  }
  .nav {
    height: 48px;
    line-height: 48px;
    background-color: rgba(0, 0, 0, 0.8);
    background-color: #f2f2f2;
    .nav-content {
      margin-left: auto;
      margin-right: auto;
      min-width: 720px;
      max-width: 980px;
      padding: 0 20px;
      .title {
        padding: 0 12px;
        font-size: 16px;
        font-weight: bold;
        color: #f2f2f2;
        color: #666;
      }
      .btn-logout {
        padding: 0 12px;
        font-size: 14px;
        color: #f2f2f2;
        color: #666;
        transition: opacity 0.12s;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .section-content {
    margin-left: auto;
    margin-right: auto;
    min-width: 720px;
    max-width: 980px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/index.vue